import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahfashiondesign',
  templateUrl: './asahfashiondesign.component.html',
  styleUrls: ['./asahfashiondesign.component.scss']
})
export class AsahfashiondesignComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
